export enum REAGGREGATION_STATUS {
  // ! Should match the DB values
  required = -1, // 'Reaggregation Required'
  inProgress = 0, // 'Reaggregation In Progress' || 'Reaggregation  Started'
  completed = 1 // 'Reaggregation Finished Successfully'
}

export interface IReaggregationStatusIndicatorType {
  status: REAGGREGATION_STATUS;
  hasError: boolean;
}
